import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BenefitsComponent } from './components/benefits/benefits.component';
import { BookADemoComponent } from './components/book-a-demo/book-a-demo.component';
import { LandingComponent } from './landing.component';

const routes: Routes = [
  {
    path: "",
    component: LandingComponent,
  },
  {
    path: "benefits",
    component: BenefitsComponent,
  },
  {
    path: "contact",
    component: BookADemoComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
